import { AccountingPlatform, AccountingPlatformConnectionStatus, apiClient } from '@melio/javascript-sdk';

import { useCollectionApi, UseCollectionApiProps } from '../../core';
import { AccountingPlatformCollection } from './types';

type UseAccountingPlatformsProps = UseCollectionApiProps<AccountingPlatform>;

export const useAccountingPlatforms = (props: UseAccountingPlatformsProps = {}): AccountingPlatformCollection => {
  const client = apiClient.accountingPlatforms();
  const accountingPlatformsQuery = useCollectionApi<AccountingPlatform>({
    ...props,
    queryKey: 'accounting-platform',
    queryFn: client.fetch,
  });
  const activeAccountingPlatform = accountingPlatformsQuery?.data?.find(
    (accountingPlatform) => accountingPlatform.connectionStatus === AccountingPlatformConnectionStatus.Connected
  );

  return {
    ...accountingPlatformsQuery,
    activeAccountingPlatform,
    hasAccountingPlatform: !!activeAccountingPlatform,
  };
};
